import { useContext } from "react"
// import Link from "next/link";
import { NavbarLinksProps } from "@/app/types/types";
import { loadingContext } from "@/app/store/context/isLoadingContext"
import { usePathname } from "next/navigation"
import Link from "../Link";

 
const NavbarLinks = ({data} : {data:NavbarLinksProps[]}) => {
  const {setIsPageFetched} = useContext(loadingContext)
  const pathname = usePathname()

  return (
    <ul className="navbar_section_links flex items-center  ">
        {data.map((item) => (
          <li key={item.id}>
            <Link
              // onClick={()=> pathname != item.link && setIsPageFetched("loading")}
              className="_txt text-oWhite-100 text-navLinks uppercase text-400 pr-6 "
              href={item.link}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
  );
}

export default NavbarLinks;